import isEmpty from 'lodash/isEmpty';

type NullableString = String | null;

const areEmpty = (...nullableStrings: NullableString[]) =>
  nullableStrings.reduce((result, nullableString) => result && isEmpty(nullableString), true);

export default areEmpty;
